import { v4 } from 'uuid';
import { AXOS_COIN } from './lookups';

export const formatCryptoAssetWithAxx = (crypto: string) => {
    return `${crypto.toUpperCase()}/${AXOS_COIN}`;
};

export const getUuid = () => v4();
